export enum HolidayRequestStatus {
	Pending = 0,
	Approved = 10,
	Declined = 30,
	Revoked = 40,
}